import {
  FREE_PLAN_SKU,
  PREMIUM_FREE_TRIAL_SKU,
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
} from 'app/constants/freeTrial';

const oneTier = [
  {
    sku: FREE_PLAN_SKU,
    isFree: true,
    desktopOrder: 1,
    tabletOrder: 2,
    mobileOrder: 2,
    freePriceKey: 'landing_plans_free_price',
    subscriptionTitleKey: 'landing_plans_with_ads',
    benefits: [
      {
        titleId: 'landing_plans_perk_1_with_ads',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_2',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_3',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_4',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_free_perk_5',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_7',
        isActive: false,
        isVisibleOnMobile: false,
      },
    ],
  },
  {
    sku: PREMIUM_FREE_TRIAL_SKU,
    desktopOrder: 2,
    tabletOrder: 1,
    mobileOrder: 1,
    directToPayButtonKey: 'buttons_get_premium',
    freeTrialButtonKey: 'buttons_free_trial',
    billingPeriodKey: 'landing_plans_billing_period',
    subscriptionTitleKey: 'landing_plans_fan',
    planSku: PREMIUM_PLAN_1_MONTH_SKU,
    plansToShowOnBilling: [
      PREMIUM_PLAN_1_MONTH_SKU,
      PREMIUM_PLAN_3_MONTHS_SKU,
      PREMIUM_PLAN_12_MONTHS_SKU,
    ],
    benefits: [
      {
        titleId: 'landing_plans_perk_1_without_ads',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_2',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_3',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_4',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_5',
        isActive: true,
        isVisibleOnMobile: true,
      },
      {
        titleId: 'landing_plans_1T_perk_7',
        isActive: true,
        isVisibleOnMobile: true,
      },
    ],
  },
];

export default oneTier;
